import { cn } from "@/lib/utils";

interface CombinedTabSectionProps {
  title: string;
  icon: React.ReactNode;
  count?: number;
  countColor?: "blue" | "amber" | "green";
  children: React.ReactNode;
  className?: string;
}

export function CombinedTabSection({
  title,
  icon,
  count,
  countColor = "blue",
  children,
  className,
}: CombinedTabSectionProps) {
  return (
    <div className={cn("space-y-3", className)}>
      {/* Section Header */}
      <div className="flex items-center gap-2 px-1">
        <div className="flex items-center gap-2 text-lg font-semibold text-slate-900">
          {icon}
          {title}
        </div>
        {count !== undefined && count > 0 && (
          <span
            className={cn(
              "ml-1 px-2 py-0.5 text-xs font-medium rounded-full",
              countColor === "amber" && "bg-amber-100 text-amber-700",
              countColor === "blue" && "bg-blue-100 text-blue-700",
              countColor === "green" && "bg-green-100 text-green-700",
            )}
          >
            {count}
          </span>
        )}
      </div>

      {/* Section Content */}
      {children}
    </div>
  );
}
